import React from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import CustomButton from '../components/Button';
import styles from './approvalModal.module.scss';

interface ApprovalModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: (changeSubentries: boolean) => void;
  loading?: boolean;
  variant?: 'internal' | 'external';
}

const ApprovalModal: React.FC<ApprovalModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  loading = false,
  variant = 'internal',
}) => {
  return (
    <Modal
      centered
      title={
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>Approve Status</span>
          <CloseOutlined onClick={onCancel} className={styles.closeIcon} />
        </div>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      className={`${styles.approvalModal} ${variant === 'external' ? styles.approvalModalExternal : ''}`}
      width={600}
    >
      <div className={styles.modalContent}>
        <div className={styles.content}>
          <p className={styles.mainTextLead}>
            All comments will be resolved for approved status.
          </p>
          <p className={styles.mainTextQuestion}>Would you like to continue with approval?</p>
        </div>

        <div className={styles.actionButtons}>
          <CustomButton onClick={onCancel} className={styles.cancelButton} type="default">
            Cancel
          </CustomButton>
          <CustomButton
            onClick={() => onConfirm(true)}
            loading={loading}
            className={styles.confirmButton}
            type="primary"
          >
            Continue
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default ApprovalModal;
